import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { setChart, saveConfig, updateAvgChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../ThroughputHistogramActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import AvgThroughput from '../components/AvgThroughput';
import ThroughputHistogramChart from './../components/ThroughputHistogramChart';

import { trackTeamDashboardView, trackHowToOpened } from '../../../util/mixpanel';

import './../ThroughputHistogram.scss';
import ChartDownloadMenu from '../../../components/ChartDownloadMenu';
import ZoomControlButton from '../../../components/ZoomControlButton';
import chartUtils from '../../../util/chartUtils';

class ThroughputHistogram extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleChange = this.handleChange.bind(this);

    props.dispatch(setPageName('Throughput histogram'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('th');

      trackTeamDashboardView('th');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.dataIsLoading != this.props.dataIsLoading && newProps.dataIsLoading === false) {
      this.handleChange(true);
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.props.getData();
    }
  }

  trackHowToTHOpen() {
    trackHowToOpened('th');
  }

  handleCloseAverages = () => {
    this.props.closeAverages();
    this.props.saveConfig();
  };

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <h4>Throughput Histogram</h4>
          <p>Shows the distribution of throughput, with completed items per period horizontally and number of periods vertically. Dashed lines mark the selected percentiles.</p>
          <p><b>Look for:</b> a wide spread, which can indicate throughput varied substantially.</p>
          <a
            href={`https://getnave.com/throughput-histogram`}
            target="_blank"
            onClick={this.trackHowToTHOpen}
            onAuxClick={this.trackHowToTHOpen}
            className='more_info-link'
            >
              Learn more →
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data, (p, c) => {
      return p + _.reduce(c.data, (p, c) => p + c.details.length, 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Throughput Histogram${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} showAvgChart enablePercentiles excludeZero navigator timeunit dateformat />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Throughput Histogram</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options showAvgChart options={{ avgChartTooltip: 'Throughput averages' }} />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details">
            {this.props.avgChart && (chartUtils.hasValues(this.props.data) ? (
              <AvgThroughput
                data={this.props.data}
                excludeZeroDays={this.props.excludeZeroDays}
                timeUnit={this.props.timeUnit}
                excludeWeekendOpts={{ type: this.props.excludeWeekends, holidays: this.props.holidays }}
                dateFormat={this.props.dateFormat}
                widget="avt"
              />
            ) : (
              <CardPlaceholder title="Throughput averages" shape="line" loading={this.props.detailsIsLoading || this.props.isLoading} onClose={this.handleCloseAverages} />
            ))}
          </div>
          <div className="diagram_details">
            <ZoomControlButton />
            <ChartDownloadMenu chartId="ThroughputHistogram" />
            <ThroughputHistogramChart id="ThroughputHistogram" data={this.props.data} />
            <NoData show={!chartUtils.hasValues(this.props.data)} loading={this.props.detailsIsLoading || this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    closeAverages: () => dispatch(updateAvgChart(false, 'th')),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    excludeWeekends: state.filters.excludeWeekends,
    holidays: state.filters.holidays,
    hash: state.filters.th.hash,
    avgChart: state.filters.th.avgChart,
    excludeZeroDays: state.filters.th.excludeZeroDays,
    timeUnit: state.filters.th.timeUnit,
    data: state.throughputHistogram.data,
    dashboard: state.dashboards.selected,
    isLoading: state.throughputHistogram.isLoading,
    detailsIsLoading: state.throughputHistogram.detailsIsLoading,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThroughputHistogram);
